export default function timeAgo(firestoreTimestamp) {
    // Convert Firestore Timestamp to milliseconds
    const timestampMillis = firestoreTimestamp.toMillis();
    const currentTimestamp = Date.now();
    const milliseconds = currentTimestamp - timestampMillis;

    const seconds = Math.floor(milliseconds / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const months = Math.floor(days / 30);
    const years = Math.floor(months / 12);

    if (years > 0) {
        return years === 1 ? "mwaka 1 uliopita" : `${years} years ago`;
    } else if (months > 0) {
        return months === 1 ? "a month ago" : `${months} months ago`;
    } else if (days > 0) {
        return days === 1 ? "siku 1 iliyopita" : `siku ${days} zilizopita`;
    } else if (hours > 0) {
        return hours === 1 ? "an hour ago" : `${hours} hours ago`;
    } else if (minutes > 0) {
        return minutes === 1 ? "a minute ago" : `${minutes} minutes ago`;
    } else {
        return seconds < 5 ? "just now" : `${seconds} seconds ago`;
    }
}


function getFirstWord(str) {
    const trimmedStr = str.trim(); // Trim to remove leading/trailing spaces
    const match = trimmedStr.match(/\S+/); // Match the first sequence of non-space characters
    return match ? match[0] : ''; // Return the matched word or an empty string
}

export {getFirstWord};